'use strict';

var map = require('lodash/map');
var PhotoSwipe = require('photoswipe');
var PhotoSwipeUI_Default = require('photoswipe/dist/photoswipe-ui-default.js');
var $ = require('jquery');

require('slick-carousel');

var SELECTORS = {
    INLINEGALLERY: '.js-inline-gallery',
    INLINEGALLERYLIST: ' .js-inline-gallery__list',
    GALLERYPOPUP: '.js-gallery-popup'
};

function popup(elem) {
    elem.find(SELECTORS.GALLERYPOPUP).on('click', function() {
        var pswpElement = elem.find('.pswp');
        var galleryElems = elem.find('.gallery-item');
        var galleryIndex = $(this)
            .parents('.inline-gallery__item')
            .data('slickIndex');

        var items = map(galleryElems, function(item) {
            return {
                src: item.getAttribute('data-large-src'),
                w: item.getAttribute('data-width'),
                h: item.getAttribute('data-height'),
                title: [
                    '<p class="pswp__caption-text">',
                    item.getAttribute('data-caption'),
                    '</p>',
                    '<span class="pswp__credit">',
                    item.getAttribute('data-credit'),
                    '</p>'
                ].join('')
            };
        });

        var options = {
            index: galleryIndex,
            shareEl: false,
            zoomEl: false,
            barsSize: { top: 20, bottom: 20 }
        };

        var gallery = new PhotoSwipe(
            pswpElement[0],
            PhotoSwipeUI_Default,
            items,
            options
        );

        gallery.init();
    });
}

function slider(elem) {
    elem.find(SELECTORS.INLINEGALLERYLIST).each(function() {
        var $el = $(this);
        var $slideNum = $el.find('.gallery-item__slide-number');

        $el.on('init reInit afterChange', function(event, slick, currentSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            $slideNum.text(i + '/' + slick.slideCount);
        });

        $el.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase: 'linear',
            speed: 300,
            fade: true,
            adaptiveHeight: true
        });
    });
}

function init() {
    $(SELECTORS.INLINEGALLERY).each(function() {
        var elem = $(this);
        popup(elem);
        slider(elem);
    });
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./modules/inlineGallery.js